// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  if (chunkId === 105) return "static/css/105.6a8b5496.css";
if (chunkId === 752) return "static/css/752.9906050d.css";
  // return url for filenames based on template
  return "" + chunkId + ".css"
}